import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  card: {
    borderRadius: "16px",
    paddingTop: theme.spacing(2),
  },
  btnScanWrapper: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  documentWrapper: {
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(4),
  },
  btnScan: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    padding: "12px",
    fontSize: "1.5rem",
    [theme.breakpoints.down("sm")]: {
      padding: "10px",
      fontSize: "1.2rem",
    },
  },
  iconScan: {
    paddingRight: "15px",
    height: "40px",
    width: "40px",
    [theme.breakpoints.down("sm")]: {
      height: "30px",
      width: "30px",
    },
  },
}));
